module.exports = __webpack_public_path__ + "static/media/logo_rounded.ca37891f.png";